import request from '@/config/axios'
import { asCapacityPage, type CapacityPageResult } from '@/api/capacity/page'

/** 平台运营：机构开通 / 清算（禁止发码、审入驻、派单） */

export interface OrgItem {
  orgId: string
  name: string
  city: string
  status: string
  inviteCode?: string
  depositOutcome?: string
  depositNote?: string
  source?: string
  applicantMerchantUserId?: number
  contactPhone?: string
  rejectReason?: string
  licenseNo?: string
  licenseUrl?: string
  legalPerson?: string
  idCardFront?: string
  idCardBack?: string
  contactEmail?: string
  loginUsername?: string
}

export interface OrgActResult {
  success: boolean
  message?: string
  orgId?: string
  joinId?: string
  inviteCode?: string
  waybillId?: string
  code?: string
}

export interface LiquidationChecklist {
  orgId: string
  status: string
  noActiveOrders: boolean
  billsSettled: boolean
  inviteVoided: boolean
  ridersDetached: boolean
  depositRecorded: boolean
  canClose: boolean
}

const BASE = '/capacity/platform/org'

export const orgCreate = (data: {
  orgId: string
  name: string
  city: string
  contactPhone?: string
}) => request.post<OrgItem>({ url: `${BASE}/create`, data })

/** 运营添加：建 B 账号 + 开通 active */
export const orgCreateWithAccount = (data: {
  orgId?: string
  name: string
  city: string
  contactPhone: string
  contactEmail?: string
  licenseNo?: string
  licenseUrl?: string
  legalPerson?: string
  idCardFront?: string
  idCardBack?: string
  loginUsername?: string
  loginPassword: string
}) =>
  request.post<{
    success: boolean
    message?: string
    orgId?: string
    loginUsername?: string
    accountId?: number
    inviteCode?: string
  }>({ url: `${BASE}/create-with-account`, data })

export const orgActivate = (orgId: string) =>
  request.post<OrgActResult>({ url: `${BASE}/activate`, params: { orgId } })

export const orgList = async (params?: {
  status?: string
  pageNo?: number
  pageSize?: number
}): Promise<CapacityPageResult<OrgItem>> => {
  const raw = await request.get({
    url: `${BASE}/list`,
    params: {
      status: params?.status,
      pageNo: params?.pageNo,
      pageSize: params?.pageSize
    }
  })
  return asCapacityPage<OrgItem>(raw, params?.pageNo, params?.pageSize)
}

export const orgApplications = () =>
  request.get<OrgItem[]>({ url: `${BASE}/applications` })

export const orgApprove = (orgId: string) =>
  request.post<OrgActResult>({ url: `${BASE}/approve`, params: { orgId } })

export const orgReject = (data: { orgId: string; reason: string }) =>
  request.post<OrgActResult>({ url: `${BASE}/reject`, data })

export const orgAdvance = (orgId: string, targetStatus: string) =>
  request.post<OrgActResult>({
    url: `${BASE}/liquidation/advance`,
    params: { orgId, targetStatus }
  })

export const orgContinueLiquidation = (orgId: string) =>
  request.post<OrgActResult>({
    url: `${BASE}/liquidation/continue`,
    params: { orgId }
  })

export const orgClose = (orgId: string, depositOutcome: string, depositNote?: string) =>
  request.post<OrgActResult>({
    url: `${BASE}/liquidation/close`,
    params: { orgId, depositOutcome, depositNote }
  })

export const orgChecklist = (orgId: string) =>
  request.get<LiquidationChecklist>({
    url: `${BASE}/liquidation/checklist`,
    params: { orgId }
  })

export const orgLiqMessages = (phone: string) =>
  request.get<string[]>({ url: `${BASE}/liquidation/messages`, params: { phone } })
